<!-- <p>outage works!</p> -->
<div *ngIf="showChart" class="chart-wrapper">

  <canvas width="1000 rem" baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
    [plugins]="barChartPlugins" [legend]="barChartLegend" [chartType]="barChartType">
    <!-- <a href="google.com"></a> -->
  </canvas>
</div>
